import {
	makeContextConsumerHook,
	makeWithContextProviderHOC,
} from "@contexts/utils";
import React, { createContext } from "react";

const GatsbyPageContext = createContext(null);

export const GatsbyPageContextProvider = ({ children, ...context }) => {
	return (
		<GatsbyPageContext.Provider value={context}>
			{children}
		</GatsbyPageContext.Provider>
	);
};

export const useGatsbyPageContext = makeContextConsumerHook(GatsbyPageContext);

export const withGatsbyPageContextProvider = makeWithContextProviderHOC(
	GatsbyPageContext.Provider,
);

export default GatsbyPageContext;
